export default __webpack_public_path__ + "static/media/designation-outline-16px.4e90614c.svg";